import { HttpClient } from '@angular/common/http';
import { AppConfig } from 'src/app/app.config';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../app.config";
var CommonService = /** @class */ (function () {
    function CommonService(http, config) {
        this.http = http;
        this.config = config;
    }
    CommonService.prototype.getNazioni = function () {
        return this.http.get(this.config.getConfig("apiEndpoint") + "/commons/countries");
    };
    // getStatiServizio() {
    // 	return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/commons/servicestatus`);
    // }
    // getStatiFornServizio() {
    // 	return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/commons/servicefornstatus`);
    // }
    // getTipologieServizio() {
    // 	return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/commons/servicetype`);
    // }
    CommonService.prototype.getCodiciIva = function () {
        return this.http.get(this.config.getConfig("apiEndpoint") + "/commons/vatcodes");
    };
    CommonService.prototype.getIva = function (id) {
        return this.http.get(this.config.getConfig("apiEndpoint") + "/commons/vatcodes/" + id);
    };
    CommonService.prototype.deleteIva = function (id) {
        return this.http.delete(this.config.getConfig("apiEndpoint") + "/commons/vatcodes/" + id);
    };
    CommonService.prototype.upsertIva = function (data) {
        return this.http.post(this.config.getConfig("apiEndpoint") + "/commons/vatcodes", data);
    };
    CommonService.ngInjectableDef = i0.defineInjectable({ factory: function CommonService_Factory() { return new CommonService(i0.inject(i1.HttpClient), i0.inject(i2.AppConfig)); }, token: CommonService, providedIn: "root" });
    return CommonService;
}());
export { CommonService };
